export default class AgentVoiceOpenUrlEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));
    if (!body.url.match(/^https?:\/\//i)) {
      body.url = 'http://' + body.url;
    }
    window.open(body.url, '_blank');
  }
}
